import { UiQueries } from './UiQueries';

export function hasWorkCenterFilterQuery(this: UiQueries): boolean {
  if (this.uiState.workCenterFilter == null) {
    return false;
  }

  return true;
}
